<template>
  <div style="height: 100%">
    <v-card
      class="modern-stat-card"
      height="100%"
      v-on="clickable ? { click: clicked } : {}"
      :class="data.selected ? 'selected-card' : 'unselected-card'"
    >
      <div
        class="d-flex flex-column flex-lg-row align-center pa-3 pa-sm-5 pe-sm-1"
      >
        <div
          class="
            text-center text-lg-start
            flex-grow-1 flex-shrink-0
            order-1 order-lg-0
          "
        >
          <div class="stat-value">{{ data.value }}</div>
          <div class="stat-label">{{ data.text }}</div>
        </div>

        <!-- <vue-feather :type="data.icon" class="pa-2 order-0 order-sm-1"></vue-feather> -->
        <v-icon
          :color="data.selected ? 'white' : 'primary'"
          class="pa-2 order-0 order-lg-1 stat-icon"
          >{{ data.icon }}</v-icon
        >
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      clickable: false,
    };
  },
  props: {
    data: {
      type: Object,
    },
  },
  created() {
    if (this.$route.name === "Home" || this.$route.name === "Courses") {
      this.clickable = true;
    }
  },
  methods: {
    clicked() {
      this.$emit("onClick");
    },
  },
};
</script>

<style scoped>
.modern-stat-card {
  border-radius: 16px !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
  cursor: pointer;
}
.unselected-card {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 4px 15px 0 rgba(31, 38, 135, 0.05) !important;
  color: #333 !important;
}
.unselected-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px 0 rgba(31, 38, 135, 0.1) !important;
  border-color: rgba(89, 40, 229, 0.2);
}
.selected-card {
  background: linear-gradient(135deg, #5928e5, #8c62ff) !important;
  color: white !important;
  box-shadow: 0 8px 25px rgba(89, 40, 229, 0.3) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.selected-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 30px rgba(89, 40, 229, 0.4) !important;
}
.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 4px;
}
.stat-label {
  font-size: 0.85rem;
  font-weight: 500;
  opacity: 0.85;
}
.stat-icon {
  font-size: 28px !important;
  opacity: 0.9;
}
</style>
